
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexhKP0IsWenCI6K_A_45PRo_4NrKs_45rIBNC6ZxcovvFwRBEMeta } from "/home/vsts/work/1/s/src/website/NLO.Krasloten.Frontend/pages/mijn/index.vue?macro=true";
import { default as scansY1UReJn24jknB1xFGZG3_45HyADUcjg4csH8REH9FxVLoMeta } from "/home/vsts/work/1/s/src/website/NLO.Krasloten.Frontend/pages/mijn/scans.vue?macro=true";
import { default as punteneFr21hMVPZar_45cpx0W_EGzXpza9j1PBKAttmJuwU1MwMeta } from "/home/vsts/work/1/s/src/website/NLO.Krasloten.Frontend/pages/mijn/punten.vue?macro=true";
import { default as bonussenwAlATlka2Jv4USFMKdrYMhiEHbAF9fiSIXVG48lUL4wMeta } from "/home/vsts/work/1/s/src/website/NLO.Krasloten.Frontend/pages/mijn/bonussen.vue?macro=true";
import { default as vouchers6BPJu2gjwOEjlZSDRuJKi6bmsJ86EGxWUOMPqETkZO0Meta } from "/home/vsts/work/1/s/src/website/NLO.Krasloten.Frontend/pages/mijn/vouchers.vue?macro=true";
import { default as indexCF8XUXpj4cs_45GK1QL7Zsb55y9QPt21wpattgzdcMjvkMeta } from "/home/vsts/work/1/s/src/website/NLO.Krasloten.Frontend/pages/mijn/deals/index.vue?macro=true";
import { default as bestellingen36OlcX_45_45lj8FPZ4gOv8ht4p8HEIlqhvU5aPZY_45_45EVM4Meta } from "/home/vsts/work/1/s/src/website/NLO.Krasloten.Frontend/pages/mijn/bestellingen.vue?macro=true";
import { default as _91deal_45id_93B_45rgAwNnCDo6Qkhll2Az437_451aKFuHKbiGTNovGciXwMeta } from "/home/vsts/work/1/s/src/website/NLO.Krasloten.Frontend/pages/mijn/deals/[deal-id].vue?macro=true";
import { default as mijna5uWWFvH1iLbYM6tV0nn_45qCu0IaBS43IPFMlQBvQ4zEMeta } from "/home/vsts/work/1/s/src/website/NLO.Krasloten.Frontend/pages/mijn.vue?macro=true";
import { default as _91_46_46_46path_93_45yIkrSFBA7JZ7XUANZ6RF3y8hZyQJIdK3yFxAyYL9K4Meta } from "/home/vsts/work/1/s/src/website/NLO.Krasloten.Frontend/pages/[...path].vue?macro=true";
import { default as indexHt2Hacnefw_9wl7De8vVP0iNinZNtg595_45irw1_45AzDEMeta } from "/home/vsts/work/1/s/src/website/NLO.Krasloten.Frontend/pages/krasloten/index.vue?macro=true";
import { default as _91slug_45gameid_93uwiYBNhX1vsdDZYkRnDssntd4UYrnUwD8q2Zq_kjpFUMeta } from "/home/vsts/work/1/s/src/website/NLO.Krasloten.Frontend/pages/krasloten/[slug-gameid].vue?macro=true";
export default [
  {
    name: mijna5uWWFvH1iLbYM6tV0nn_45qCu0IaBS43IPFMlQBvQ4zEMeta?.name,
    path: "/mijn",
    component: () => import("/home/vsts/work/1/s/src/website/NLO.Krasloten.Frontend/pages/mijn.vue"),
    children: [
  {
    name: "mijn",
    path: "",
    component: () => import("/home/vsts/work/1/s/src/website/NLO.Krasloten.Frontend/pages/mijn/index.vue")
  },
  {
    name: "mijn-scans",
    path: "scans",
    component: () => import("/home/vsts/work/1/s/src/website/NLO.Krasloten.Frontend/pages/mijn/scans.vue")
  },
  {
    name: "mijn-punten",
    path: "punten",
    component: () => import("/home/vsts/work/1/s/src/website/NLO.Krasloten.Frontend/pages/mijn/punten.vue")
  },
  {
    name: "mijn-bonussen",
    path: "bonussen",
    component: () => import("/home/vsts/work/1/s/src/website/NLO.Krasloten.Frontend/pages/mijn/bonussen.vue")
  },
  {
    name: "mijn-vouchers",
    path: "vouchers",
    component: () => import("/home/vsts/work/1/s/src/website/NLO.Krasloten.Frontend/pages/mijn/vouchers.vue")
  },
  {
    name: "mijn-deals",
    path: "deals",
    component: () => import("/home/vsts/work/1/s/src/website/NLO.Krasloten.Frontend/pages/mijn/deals/index.vue")
  },
  {
    name: "mijn-bestellingen",
    path: "bestellingen",
    component: () => import("/home/vsts/work/1/s/src/website/NLO.Krasloten.Frontend/pages/mijn/bestellingen.vue")
  },
  {
    name: "mijn-deals-dealid",
    path: "deals/:dealid()",
    component: () => import("/home/vsts/work/1/s/src/website/NLO.Krasloten.Frontend/pages/mijn/deals/[deal-id].vue")
  }
]
  },
  {
    name: "path",
    path: "/:path(.*)*",
    component: () => import("/home/vsts/work/1/s/src/website/NLO.Krasloten.Frontend/pages/[...path].vue")
  },
  {
    name: "krasloten",
    path: "/krasloten",
    component: () => import("/home/vsts/work/1/s/src/website/NLO.Krasloten.Frontend/pages/krasloten/index.vue")
  },
  {
    name: "krasloten-sluggameid",
    path: "/krasloten/:sluggameid()",
    component: () => import("/home/vsts/work/1/s/src/website/NLO.Krasloten.Frontend/pages/krasloten/[slug-gameid].vue")
  }
]